<template>
  <div class="container" :class="{'active': !isHidden}">
    <div>
    <div class="controll-wrapper">
      <div class="item buttons">
        <span @click="filterProducts" v-if="selected.length !== 0" class="ye-button mr-10">Показать</span>
        <span @click="clearFilter" v-if="selected.length !== 0" class="lye-button">Сбросить</span>
      </div>
      <div class="item close">
        <svg @click="hideFilter" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
        <g>
          <g>
            <path d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872
              c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872
              c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052
              L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116
              c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952
              c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116
              c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"/>
          </g>
        </g>
        </svg>
      </div>
    </div>
    <ul>
      <li :key="filter.group_id" v-for="filter in filters">
        <p>{{ filter.name }}</p>
        <ul>
          <li :key="value.id" v-for="value in filter.values">
            <label :class="{'disabled': !cheeckAvailabelFilter({group_id:filter.group_id, value: value})}"><input :disabled="!cheeckAvailabelFilter({group_id:filter.group_id, value: value})" v-model="selected" :value="{group_id:filter.group_id, value: value}" type="checkbox"/> {{ value.name }}</label>
          </li>
        </ul>
      </li>
    </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductFilter",
  props: ['filters', 'filterAvailable'],
  data() {
    return {
      isHidden: true,
      selected: []
    }
  },
  watch: {
    selected(){
      this.$emit('setSelected', this.selected);
    }
  },
  methods: {
    cheeckAvailabelFilter(item){

      if (this.filterAvailable.length == 0) {

        return true
      }

      let availableItem = this.filterAvailable.find(f => f.group_id === item.group_id)
      // console.log(availableItem)
      if (!availableItem) {

        return false
      }
      let value = availableItem.values.find(v=> v == item.value.id)
      if (!value) {

        return false
      }

      return true

    },
    clearFilter(){
      this.selected = []
      this.$emit('setSelected', this.selected);
      this.filterProducts()
    },
    filterProducts() {
      this.hideFilter()
      this.$emit('filterProducts');
    },
    showFilter () {
      this.isHidden = false
    },
    hideFilter () {
      this.isHidden = true
    }
  },
}
</script>

<style scoped>
.disabled {
  opacity: 0.5;
}
.active {
  transform: translateX(350px);
}
ul {
  list-style: none;
  text-align: left;
  padding: 0;
  margin: 0;
}
ul>li {
  font-size: 14px;
}
p {
  font-size: 15px;
  font-weight: 500;
}
.container {
  background: #f2f2f2;
  padding: 20px;
  position: fixed;
  height: 100%;
  width: 350px;
  top: 0;
  z-index: 1000;
  overflow-y: scroll;
  transition: transform .4s ease-in-out;
  left: -350px;
}
.controll-wrapper {
  display: flex;
  margin-top: 15px;
  margin-bottom: 35px;
}
.close {
  width: 10%;
}
.buttons {
  width: 90%;
  text-align: left;
}
svg {
  width: 15px;
  cursor: pointer;
}
</style>